module.exports = __webpack_public_path__ + "static/media/Instagram.c1b5701c.svg";